import { EditableTextPanel } from "./EditableTextPanel";

/** Internal notes in the rail. A prospect's page titles them "Why they should sell". */
export function RailNotes({ value, onSave, title = "Internal notes" }: {
  value: string | null | undefined; onSave: (v: string) => Promise<unknown>; title?: string;
}) {
  return <EditableTextPanel id="record-notes" title={title} value={value} onSave={onSave} emptyText="No notes yet." />;
}
